export type { CmdbObjectPickerDumbProps, CmdbObjectPickerOption } from './cmdb-object-picker-dumb';
export { default as CmdbObjectPickerDumb } from './cmdb-object-picker-dumb';
